import { URLS } from "@constants/urls";
import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEE}`;

export const passwordReset = async (employeeId: number) => {
  const response = await api.post(
    `${apiEndPoint}/${employeeId}/${URLS.RESET_PASSWORD}`,
    {
      resetPassword: true,
    },
  );
  return response.data;
};
